var _rect, _circle, _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path0, _mask6, _path1, _path10, _mask7, _path11, _path12, _mask8, _path13, _path14, _mask9, _path15, _path16, _path17, _path18, _mask0, _path19, _path20, _mask1, _path21, _path22, _mask10, _path23, _path24, _mask11, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperienceprofileFavicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_4063_10704)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 32.5819,
    fill: "white",
    stroke: "#F1F1F1",
    strokeWidth: 0.163728
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 28.3359,
    y: 20.4495,
    width: 12,
    height: 21,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 28.3359,
    y: 20.4495,
    width: 12,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0299 25.0142C32.1864 22.7209 35.9821 21.4743 39.8837 21.4498L40.0009 40.1145L29.0299 25.0142Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0299 25.0142C32.1864 22.7209 35.9821 21.4743 39.8837 21.4498L40.0009 40.1145L29.0299 25.0142Z",
    fill: "#19A3AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0299 25.0142C32.1864 22.7209 35.9821 21.4743 39.8837 21.4498L40.0009 40.1145L29.0299 25.0142Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-3-outside-1_4063_10704)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-2_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 39.4953,
    y: 24.0214,
    width: 19.1233,
    height: 16.1466,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 39.4953,
    y: 24.0214,
    width: 19.1233,
    height: 16.1466
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1354 24.6431C54.3095 26.9119 56.6928 30.1183 57.9504 33.8117L40.2816 39.8278L51.1354 24.6431Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1354 24.6431C54.3095 26.9119 56.6928 30.1183 57.9504 33.8117L40.2816 39.8278L51.1354 24.6431Z",
    fill: "#FD262A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1354 24.6431C54.3095 26.9119 56.6928 30.1183 57.9504 33.8117L40.2816 39.8278L51.1354 24.6431Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-4-outside-2_4063_10704)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-3_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 15.6614,
    y: 38.943,
    width: 29.6393,
    height: 23.1626,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 15.6614,
    y: 38.943,
    width: 29.6393,
    height: 23.1626
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1323 60.1257C20.9375 57.0492 17.8121 52.7354 16.1957 47.7908L39.8503 40.0577L25.1323 60.1257Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1323 60.1257C20.9375 57.0492 17.8121 52.7354 16.1957 47.7908L39.8503 40.0577L25.1323 60.1257Z",
    fill: "#A3D95D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1323 60.1257C20.9375 57.0492 17.8121 52.7354 16.1957 47.7908L39.8503 40.0577L25.1323 60.1257Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-5-outside-3_4063_10704)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-4_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 27.4298,
    y: 29.2718,
    width: 13.086,
    height: 11.1017,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 27.4298,
    y: 29.2718,
    width: 13.086,
    height: 11.1017
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0906 35.967C28.8749 33.487 30.4167 31.3151 32.4991 29.7567L39.9547 39.7191L28.0906 35.967Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0906 35.967C28.8749 33.487 30.4167 31.3151 32.4991 29.7567L39.9547 39.7191L28.0906 35.967Z",
    fill: "#33D1B1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0906 35.967C28.8749 33.487 30.4167 31.3151 32.4991 29.7567L39.9547 39.7191L28.0906 35.967Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-6-outside-4_4063_10704)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-5_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 16.2031,
    y: 19.2278,
    width: 25,
    height: 22,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 16.2031,
    y: 19.2278,
    width: 25,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4212 32.424C18.0287 27.4765 21.1462 23.1571 25.3356 20.073L40.0898 40.1144L16.4212 32.424Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4212 32.424C18.0287 27.4765 21.1462 23.1571 25.3356 20.073L40.0898 40.1144L16.4212 32.424Z",
    fill: "#33D1B1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4212 32.424C18.0287 27.4765 21.1462 23.1571 25.3356 20.073L40.0898 40.1144L16.4212 32.424Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-7-outside-5_4063_10704)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-6_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 31.6842,
    y: 36.7933,
    width: 9.22631,
    height: 7.43069,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 31.6842,
    y: 36.7933,
    width: 9.22631,
    height: 7.43069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9338 41.7092C33.5981 40.5415 33.6117 39.3011 33.9727 38.1411L39.9133 39.9902L33.9338 41.7092Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9338 41.7092C33.5981 40.5415 33.6117 39.3011 33.9727 38.1411L39.9133 39.9902L33.9338 41.7092Z",
    fill: "#4CB37A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9338 41.7092C33.5981 40.5415 33.6117 39.3011 33.9727 38.1411L39.9133 39.9902L33.9338 41.7092Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-8-outside-6_4063_10704)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-7_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 7.97461,
    y: 29.9406,
    width: 33,
    height: 20,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7.97461,
    y: 29.9406,
    width: 33,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4972 49.6618C8.48773 43.4775 8.46681 36.8188 10.4373 30.6219L40.0829 40.0489L10.4972 49.6618Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4972 49.6618C8.48773 43.4775 8.46681 36.8188 10.4373 30.6219L40.0829 40.0489L10.4972 49.6618Z",
    fill: "#4CB37A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4972 49.6618C8.48773 43.4775 8.46681 36.8188 10.4373 30.6219L40.0829 40.0489L10.4972 49.6618Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-9-outside-7_4063_10704)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-8_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 39.7144,
    y: 39.4706,
    width: 13.0334,
    height: 11.0395,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 39.7144,
    y: 39.4706,
    width: 13.0334,
    height: 11.0395
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1187 43.8744C51.3225 46.3505 49.7703 48.515 47.6803 50.0634L40.2728 40.0652L52.1187 43.8744Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1187 43.8744C51.3225 46.3505 49.7703 48.515 47.6803 50.0634L40.2728 40.0652L52.1187 43.8744Z",
    fill: "#FF652D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1187 43.8744C51.3225 46.3505 49.7703 48.515 47.6803 50.0634L40.2728 40.0652L52.1187 43.8744Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-10-outside-8_4063_10704)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-outside-9_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 39.3359,
    y: 39.4495,
    width: 19,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 39.3359,
    y: 39.4495,
    width: 19,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7524 45.8822C56.5467 49.5929 54.2086 52.8324 51.0666 55.1455L40.0009 40.1145L57.7524 45.8822Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7524 45.8822C56.5467 49.5929 54.2086 52.8324 51.0666 55.1455L40.0009 40.1145L57.7524 45.8822Z",
    fill: "#FF652D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7524 45.8822C56.5467 49.5929 54.2086 52.8324 51.0666 55.1455L40.0009 40.1145L57.7524 45.8822Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-11-outside-9_4063_10704)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5637 65.1751C53.2842 68.9971 46.7337 71.3084 40.4133 71.1002L40.3341 71.0973L40.334 71.019L40.1301 40.371L40.1283 40.1203L40.2778 40.3219L58.5815 65.0597L58.631 65.1264L58.5637 65.1751Z",
    fill: "#E49E10",
    stroke: "white",
    strokeWidth: 0.163728
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7559 8.85852C46.2736 8.85852 52.935 10.8275 57.9326 14.7023L57.9951 14.7511L57.9492 14.8146L40.1426 39.7599L39.9971 39.964L39.9941 39.713L39.6738 8.94153L39.6729 8.85852H39.7559Z",
    fill: "#B30A0A",
    stroke: "white",
    strokeWidth: 0.163728
  })), _mask0 || (_mask0 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-outside-10_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 39.1786,
    y: 25.251,
    width: 29.5284,
    height: 22.8672,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 39.1786,
    y: 25.251,
    width: 29.5284,
    height: 22.8672
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8013 31.826C65.5036 36.7417 65.6226 42.0673 64.1416 47.0542L40.2847 39.9694L63.8013 31.826Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8013 31.826C65.5036 36.7417 65.6226 42.0673 64.1416 47.0542L40.2847 39.9694L63.8013 31.826Z",
    fill: "#F76363"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8013 31.826C65.5036 36.7417 65.6226 42.0673 64.1416 47.0542L40.2847 39.9694L63.8013 31.826Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-14-outside-10_4063_10704)"
  })), _mask1 || (_mask1 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-outside-11_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 35.1109,
    y: 39.0244,
    width: 8.92571,
    height: 9.36172,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 35.1109,
    y: 39.0244,
    width: 8.92571,
    height: 9.36172
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.933 46.3318C38.7198 46.2661 37.5524 45.8466 36.5749 45.1251L40.2696 40.1193L39.933 46.3318Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.933 46.3318C38.7198 46.2661 37.5524 45.8466 36.5749 45.1251L40.2696 40.1193L39.933 46.3318Z",
    fill: "#FFC200"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.933 46.3318C38.7198 46.2661 37.5524 45.8466 36.5749 45.1251L40.2696 40.1193L39.933 46.3318Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-15-outside-11_4063_10704)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-outside-12_4063_10704",
    maskUnits: "userSpaceOnUse",
    x: 28.3359,
    y: 39.4495,
    width: 12,
    height: 20,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 28.3359,
    y: 39.4495,
    width: 12,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0009 58.7794C36.0993 58.7794 32.2958 57.5568 29.125 55.2834L40.0009 40.1145V58.7794Z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0009 58.7794C36.0993 58.7794 32.2958 57.5568 29.125 55.2834L40.0009 40.1145V58.7794Z",
    fill: "#FFC200"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0009 58.7794C36.0993 58.7794 32.2958 57.5568 29.125 55.2834L40.0009 40.1145V58.7794Z",
    stroke: "white",
    strokeWidth: 0.327456,
    mask: "url(#path-16-outside-12_4063_10704)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-13_4063_10704",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.498 40.0493C35.498 37.5175 37.5505 35.465 40.0824 35.465C42.6143 35.465 44.6668 37.5175 44.6668 40.0493C44.6668 42.5812 42.6143 44.6337 40.0824 44.6337C37.5505 44.6337 35.498 42.5812 35.498 40.0493Z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.498 40.0493C35.498 37.5175 37.5505 35.465 40.0824 35.465C42.6143 35.465 44.6668 37.5175 44.6668 40.0493C44.6668 42.5812 42.6143 44.6337 40.0824 44.6337C37.5505 44.6337 35.498 42.5812 35.498 40.0493Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.498 40.0493M44.6668 40.0493M44.6668 40.0493M35.498 40.0493M40.0824 35.465M44.6668 40.0493M40.0824 44.6337M35.498 40.0493M40.0824 44.6337V44.3063C37.7314 44.3063 35.8255 42.4004 35.8255 40.0493H35.498H35.1706C35.1706 42.7621 37.3697 44.9612 40.0824 44.9612V44.6337ZM44.6668 40.0493H44.3394C44.3394 42.4004 42.4335 44.3063 40.0824 44.3063V44.6337V44.9612C42.7952 44.9612 44.9943 42.7621 44.9943 40.0493H44.6668ZM40.0824 35.465V35.7924C42.4335 35.7924 44.3394 37.6983 44.3394 40.0493H44.6668H44.9943C44.9943 37.3366 42.7952 35.1375 40.0824 35.1375V35.465ZM40.0824 35.465V35.1375C37.3697 35.1375 35.1706 37.3366 35.1706 40.0493H35.498H35.8255C35.8255 37.6983 37.7314 35.7924 40.0824 35.7924V35.465Z",
    fill: "white",
    mask: "url(#path-17-inside-13_4063_10704)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4063_10704",
    x1: 40,
    y1: 0.00000113925,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BD0404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914032,
    stopColor: "#F40000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceprofileFavicon);
export default __webpack_public_path__ + "static/media/experienceprofile-favicon.61d3342bd00a1868da627b994ab22fce.svg";
export { ForwardRef as ReactComponent };